var wSize = $(window).outerWidth();
var hSize = $(window).innerHeight();

$(document).ready(function() {

    checkOrientationWarning();
    
    /* show-up ---------------- */

    if ($('.show-up').length) {
        $('.show-up').each(function() {
            let text = $(this).html();
            $(this).html(`<span>${text}</span>`);
        });
    }

    /* DATA AOS ---------------------------------- */

    $('[data-aos]').addClass('aos-init');

    /* NAV MOBILE ------------------------------ */
    
    let headerH = $('.header-group').height();
    $('.nav-mobile').css('height', `${hSize - headerH}px`);

    header();
    mega_menu();
    productForm();
});

$(window).on('resize', function() {
    wSize = $(window).outerWidth();
    hSize = $(window).outerHeight();
    
    /* NAV MOBILE ------------------------------ */
    
    let headerH = $('.header-group').height();
    $('.nav-mobile').css('height', `${hSize - headerH}px`);

    if (wSize >= 1250) {
        $('.nav-mobile').removeClass('open');
        $('.mega-mobile').css('right', '-150%');
        
    
        $('.header').find('.menu-open').addClass('active');
        $('.header').find('.menu-close').removeClass('active');
    }
    
    mega_menu();
    productForm();
});

$(window).scroll(function() {
    header();
});

$(window).on('resize orientationchange', function() {
    checkOrientationWarning();
});

function visiblePercent($element) {
    let windowHeight = $(window).height();
    let scrollTop = $(window).scrollTop();
    let elementOffset = $element.offset().top;
    let elementHeight = $element.outerHeight();

    let distanceFromTop = elementOffset - scrollTop;
    let visiblePercent = (windowHeight - distanceFromTop) / elementHeight * 100;

    visiblePercent = Math.max(0, Math.min(100, visiblePercent));

    return visiblePercent;
}

function sectionPercent($element) {
    let elementHeight = $element.outerHeight();
    let viewportHeight = $(window).height();
    
    let elementOffset = $element.offset();
    let elementTop = elementOffset.top - $(window).scrollTop();

    let scrollPercentage = Math.min(100, Math.max(0, ((viewportHeight - elementTop) / elementHeight) * 100));

    return scrollPercentage;
}

function scrolledVH($element) {
    let viewportHeight = $(window).height();
    let elementHeight = $element.outerHeight();
    let elementTop = $element.offset().top;
    let scrollTop = $(window).scrollTop();

    let distance = scrollTop - elementTop;
    let elementHeightVH = elementHeight / viewportHeight;
    let scrolledVH = (distance / elementHeight) * elementHeightVH;

    scrolledVH = Math.min(Math.max(0, scrolledVH), elementHeightVH);

    return scrolledVH * 100;
}

function header() {
    if ($('.header').length) {
        if (window.location.pathname === '/' || window.location.pathname === '') {
            let scrollThreshold = $(window).height() * 0.2;

            if ($(window).scrollTop() > scrollThreshold)
                $('.header').addClass('active');
            else
                $('.header').removeClass('active');
        }
    }
}

$('.header .drop1 > div > .item').on('mouseover', function() {

    let $this = $(this);
    let dropValue = $this.data('drop');

    $('.header .drop .item i').css('transform', 'scale(1)');
    $this.find('i').css('transform', 'rotate(90deg)');
    
    $('.drop2').hide();
    
    if (dropValue !== undefined) {
        let $drop = $('.drop2[data-drop="' + dropValue + '"]');
        $drop.show();
    }

    $('.header').addClass('active');

});

$('.header .nav-item').on('mouseover', function() {

    $('.header .nav-items').find('.underline').css('width', '0');
    $(this).find('.underline').css('width', `${$(this).width()}px`);

    let $this = $(this);
    let dropValue = $this.data('drop');

    $('.header .nav-item i').css('transform', 'scale(1)');
    $this.find('i').css('transform', 'scale(-1)');

    $('.header .drop .item i').css('transform', 'scale(1)');
    
    $('.drop').hide();
    header();
    
    if (dropValue !== undefined) {
        let $drop = $('.drop[data-drop="' + dropValue + '"]');
        $drop.show();

        let navItemOffset = $this.offset();
        let navItemWidth = $this.outerWidth();
        let dropWidth = $drop.outerWidth();
        
        let leftPosition = navItemOffset.left + (navItemWidth / 2) - (dropWidth / 2);

        $drop.css({
            'left': leftPosition
        });
        
        $('.header').addClass('active');
    }

});

let isMouseOverDrop = false;

$('.header .nav-items').on('mouseleave', function(event) {

    let $navItems = $(this);
    let navItemsOffset = $navItems.offset();
    let navItemsWidth = $navItems.outerWidth();
    let navItemsHeight = $navItems.outerHeight();
    let buffer = 30;

    let extendedLeft = navItemsOffset.left - buffer;
    let extendedRight = navItemsOffset.left + navItemsWidth + buffer;
    let extendedTop = navItemsOffset.top - buffer;
    let extendedBottom = navItemsOffset.top + navItemsHeight + buffer;

    $(document).on('mousemove.navItemsCheck', function(event) {
        let mouseX = event.pageX;
        let mouseY = event.pageY;

        if (mouseX < extendedLeft || mouseX > extendedRight || mouseY < extendedTop || mouseY > extendedBottom) {
            if (!isMouseOverDrop) {
                $('.drop').hide();
                $('.header .nav-item i').css('transform', 'scale(1)');
                $('.header .nav-items').find('.underline').css('width', '0');

                header();
            }
        }
    });

});

$('.header .nav-items').on('mouseenter', function() {
    $(document).off('mousemove.navItemsCheck');
});

$('.drop1').on('mouseenter', function() {
    isMouseOverDrop = true;
});

$('.drop1').on('mouseleave', function() {
    isMouseOverDrop = false;
    $('.header .nav-items').trigger('mouseleave');
    header();
});

$('.header .menu-toggle').on('click', function() {

    if ($(this).find('.menu-open').hasClass('active')) {
        $('.nav-mobile').addClass('open');

    }
    else {
        $('.nav-mobile').removeClass('open');
        $('.mega-mobile').css('right', '-150%');
    }

    $(this).find('.menu-open').toggleClass('active');
    $(this).find('.menu-close').toggleClass('active');
});

$(document).on('click', '.nav-mobile .accordion-button', function (e) {
    const $target = $(e.target);

    if ($target.is('a')) {
        const href = $target.attr('href');
        
        window.location.href = href;

        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    }

    const $button = $(this).not('.has-mega');
    const target = $button.attr('data-bs-target');
    $(target).collapse('toggle');

    $button.toggleClass('collapsed');
});

$('.nav-mobile .has-mega').on('click', function() {
    $('.mega-mobile').css('right', '0');
});

$('.nav-mobile .mega-header .back').on('click', function() {
    $('.mega-mobile').css('right', '-150%');
});

function productForm() {
    let headerH = $('.header-group').height();

    $('.product').css('margin-top', `${headerH}px`);
    $('.product .sticky-top').css('top', `${headerH+30}px`);
}

$('a[href^="#"]').on('click', function(e) {
    e.preventDefault();

    let href = $(this).attr('href');
    let targetId = href.slice(1);
    let $targets = $('#' + targetId);

    if (!$targets.length) {
        $targets = $('.' + targetId);
    }

    if ($targets.length) {
        let scrollTop = $(window).scrollTop();
        let nextTarget = null;

        $targets.each(function() {
            if ($(this).offset().top - 110 > scrollTop + 1) {
                nextTarget = $(this);
                return false;
            }
        });

        if (!nextTarget) {
            nextTarget = $targets.first();
        }

        let headerH = $('.header-group').height();

        $('html, body').animate({
            scrollTop: nextTarget.offset().top - headerH
        }, 0);
    }
});

function mega_menu() {
    if ($('.header .mega-menu').length) {
        let headerH = $('.header-group').height();
        let screenH = $(window).height();
        let paddingY = parseInt($('.header .mega-menu .container').css('padding-top')) + parseInt($('.header .mega-menu .container').css('padding-bottom'));
        let minusH = $('.header .mega-menu .container .d-flex').height();

        let maxH = (screenH - headerH - paddingY - minusH) - 100;

        $('.header .mega-menu .mega-items').css('max-height', `${maxH}px`);
    }
}

function checkOrientationWarning() {
    const width = window.innerWidth;
    const height = window.innerHeight;

    // Basic mobile/tablet detection via user agent
    const isMobileOrTablet = /iPhone|iPad|Android|Mobile|Tablet|iPod/i.test(navigator.userAgent);
    const isLandscape = width > height;

    if (isMobileOrTablet && isLandscape) {
        $('#landscape-warning').css('display', 'flex');
    } else {
        $('#landscape-warning').hide();
    }
}